import { useEffect } from 'react';
import { useFlags } from 'ws-scripts/modules/common';
import {
	getDOMElements,
	validateDOMElements,
	getHeaderConfig,
	createSetVehicleToolbarVisibility,
	createVehicleCtasObserver,
	createResizeHandler,
	createAlertBannerObserver
} from '../utils';

/**
 * Custom hook to manage sticky vehicle toolbar behavior
 * Handles positioning, visibility, and responsiveness of the vehicle toolbar
 * based on scroll position, device type, and header configuration
*/
export const useStickyVehicleToolbar = () => {
	const flags = useFlags();
	const enableVehicleToolbarCalculationInWidget = flags['ws-vehicle-toolbar-dynamic-header-offset'];

	useEffect(() => {
		// temporary flag check, it will be removed later
        if (!enableVehicleToolbarCalculationInWidget) {
			return undefined;
		}
        
		const { DDC } = window;

		if (
			!DDC ||
			DDC.isComposer ||
			typeof window.IntersectionObserver === 'undefined'
		) {
			return undefined;
		}

		const dom = getDOMElements();

		// Validate required elements
		if (!validateDOMElements(dom)) {
			return undefined;
		}

		// Get configuration
		const config = getHeaderConfig({ dom, DDC });

		// Create handlers
		const setVehicleToolbarVisibility = createSetVehicleToolbarVisibility({dom,config, DDC})

		// Create observers and handlers
		const vehicleCtasObserver = createVehicleCtasObserver({
			dom,
			config,
			DDC,
			setVehicleToolbarVisibility
		});

		const resizeHandler = createResizeHandler({
			DDC,
			setupVehicleCtasObserver: vehicleCtasObserver.setup
		});

		const alertBannerObserver = createAlertBannerObserver({
			dom,
			config,
			setupVehicleCtasObserver: vehicleCtasObserver.setup
		});

		// Initialize all
		vehicleCtasObserver.setup();
		resizeHandler.setup();
		alertBannerObserver.setup();

		// Cleanup function
		return () => {
			vehicleCtasObserver.cleanup();
			resizeHandler.cleanup();
			alertBannerObserver.cleanup();
		};
	}, [enableVehicleToolbarCalculationInWidget]);
};